import * as React from 'react';
import { SvgIcon, SvgIconProps } from '@material-ui/core';

type ColorStatus = 'inProgress' | 'notStarted';

interface Props extends SvgIconProps {
  status?: ColorStatus;
  selected?: boolean;
  circleSize?: number;
}

export const QuestionStatusIcon: React.FC<Props> = ({
  status = 'notStarted',
  selected,
  circleSize = 9.5,
  ...props
}) => (
  <SvgIcon {...props}>
    <circle cx="12" cy="12" r={circleSize} fill={status === 'notStarted' ? 'lightgrey' : 'url(#grad1)'} />

    <defs>
      <linearGradient id="grad1" x1="0%" y1="0%" x2="0%" y2="100%">
        <stop offset="50%" style={{ stopColor: 'lightblue', stopOpacity: 1 }} />
        <stop offset="50%" style={{ stopColor: 'teal', stopOpacity: 1 }} />
      </linearGradient>
    </defs>

    {selected && <circle cx="12" cy="12" r={circleSize} fill="rgba(0, 0, 0, 0.20)" />}
  </SvgIcon>
);
